import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotification } from '@sib/notifications';

export const useCopyToClipboard = () => {
  const { open: openNotification } = useNotification();
  const { t } = useTranslation();

  const handleCopy = useCallback(
    (textToCopy: string) => {
      navigator.clipboard.writeText(textToCopy.toString());
      openNotification({
        message: t('copyToClipboard'),
        type: 'success',
      });
    },
    [openNotification, t]
  );

  return { handleCopy };
};
